import { $axios } from "../../config/axios";
// Include the labtest, resources operation

const state = {
  resources: [],
  vendors: [],
  labs: [],
  selectedResourceId: "",
};
const getters = {
  getArrResources: function(state) {
    return state.resources;
  },
  getObjResources: function(state) {
    const resourcesObj = {};
    state.resources.forEach((resource) => {
      resourcesObj[resource._id] = resource;
    });
    return resourcesObj;
  },
  getArrVendors: function(state) {
    return state.vendors;
  },
  getArrLabs: function() {
    return state.labs;
  },
  getObjVendors: function() {
    const vendorsObj = {};
    state.vendors.forEach((vendor) => {
      vendorsObj[vendor._id] = vendor;
    });
    return vendorsObj;
  },
  resourcesGroupByResourceType: function(state) {
    const resourceTypeResources = {};
    state.resources.forEach((resource) => {
      if (resourceTypeResources[resource.type] === undefined) {
        resourceTypeResources[resource.type] = [];
      }
      resourceTypeResources[resource.type].push(resource);
    });
    return resourceTypeResources;
  },
  getSelectedResourceId: function(state) {
    return state.selectedResourceId;
  },
};
const mutations = {
  SET_RESOURCES: function(state, resources) {
    state.resources = resources;
  },
  SET_VENDORS: function(state, vendors) {
    state.vendors = vendors;
  },
  SET_LABS: function(state, labs) {
    state.labs = labs;
  },

  SET_SELECTED_RESOURCE_ID: function(state, resourceId) {
    state.selectedResourceId = resourceId;
  },
};
const actions = {
  fetchAllLabs: async (context, params = {}) => {
    try {
      const response = await $axios.get("/labs", { params });
      context.commit("SET_LABS", response.data.labs);

      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  deleteLab: async (context, labId) => {
    console.log(labId);
    try {
      const response = await $axios.delete(`/labs/${labId}`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  // resources actions
  fetchAllResources: async (context, params = {}) => {
    try {
      const response = await $axios.get("/resources", { params });
      context.commit("SET_RESOURCES", response.data.resources);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  fetchAResource: async (context, resourceId) => {
    try {
      const response = await $axios.get(`/resources/${resourceId}`);
      return response.data;
    } catch (err) {
      return err;
    }
  },
  fetchResourceQuantityObj(context, params) {
    console.log(params.from_date, params.to_date);
  },
  changeResourceSelected(context, resourceId) {
    context.commit("SET_SELECTED_RESOURCE_ID", resourceId);
  },
  addResources: async (context, resource) => {
    try {
      const response = await $axios.post("/resources", resource);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  updateResources: async (context, resource) => {
    try {
      const response = await $axios.patch(
        `/resources/${resource._id}`,
        resource
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  deleteResource: async (context, resourceIds) => {
    try {
      const response = await $axios.delete(`/resources/${resourceIds}`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  // resource vendor actions
  fetchAllVendors: async (context, params) => {
    try {
      const response = await $axios.get("/resources/vendors", { params });
      context.commit("SET_VENDORS", response.data.resource_vendors);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  fetchAVendor: async (context, vendorId) => {
    try {
      const response = await $axios.get(`/resources/vendors/${vendorId}`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  addVendor: async (context, vendor) => {
    try {
      const response = await $axios.post("/resources/vendors", vendor);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  AddLab: async (context, lab) => {
    try {
      const response = await $axios.post("/labs", lab);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  updateLab: async (context, lab) => {
    try {
      const response = await $axios.patch(`/labs/${lab._id}`, lab);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  updateVendor: async (context, vendor) => {
    try {
      const response = await $axios.patch(
        `/resources/vendors/${vendor._id}`,
        vendor
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  deleteVendor: async (context, vendorIds) => {
    try {
      const response = await $axios.delete(`/resources/vendors/${vendorIds}`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
